interface TruckIconProps {
  readonly className?: string;
}

export function TruckIcon({ className }: TruckIconProps) {
  return (
    <svg
      viewBox="0 0 19.501 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M15.3135 0L16.1201 0.754883L16.6582 8.75L18.001 8.41406V6H19.501L19.5 9.58594L16.7607 10.2705L16.8633 11.7998L18 14.0732V21H14.6895L13.1895 19.5H6.31055L4.81055 21H1.5V14.0732L2.6377 11.7998L2.74023 10.2705L0 9.58594V6H1.5V8.41406L2.84277 8.75L3.38086 0.754883L4.18848 0H15.3135ZM4.22949 10.498L4.11426 12.1992L3.00684 14.415L4.95215 14.9014L5.38672 16.5566L3.00098 15.96V19.5H4.19043L5.69043 18H13.8115L15.3115 19.5H16.501L16.502 15.96L14.1162 16.5566L14.5498 14.9014L16.4961 14.415L15.3877 12.1992L15.2734 10.498H14.1533L12.5801 16.498H6.92285L5.34961 10.498H4.22949ZM6.89844 10.5L8.0791 15H11.4219L12.6025 10.5H10.8115L9.75098 11.5605L8.69043 10.5H6.89844ZM4.53223 6L4.33008 9H15.1719L14.9707 6H4.53223ZM4.83496 1.5L4.63184 4.5H14.8682L14.666 1.5H4.83496Z"
        fill="currentColor"
      />
    </svg>
  );
}
